import * as criteriaNames from "../enums/criteriaNames";
import * as fieldNames from "../enums/fieldNames";
import * as inputTypes from "../enums/inputTypes";

export default function getDefaultColumnsForTarget(targetFields, criteria, editors) {
	return targetFields
		.filter(field => field.default === true)
		.map(x => x.name)
		.filter(fieldName => {
			// Only include 'pdf_snippet' if user has included criteria of type 'TEXT'
			if (fieldName === fieldNames.PDF_SNIPPET) {
				return criteria.filter(c => editors[c.name].type === inputTypes.TEXT).length > 0;
			}
			// Only include 'issue_annotations' if user has created an event with an issue
			if (fieldName === fieldNames.ISSUE_ANNOTATIONS) {
				return (
					criteria.filter(c => {
						return (
							c.name === criteriaNames.EVENT ||
							(c.name === criteriaNames.EVENT_AND &&
							c.value.length && // NOTE(CK): Maybe remove this in the future
								c.value.filter(v => v.issue.length).length)
						); // NOTE(CK): Maybe remove this in the future
					}).length > 0
				);
			}
			return true;
		});
}
